/* -disable react/no-unused-state */
/**
 * NOTA IMPORTANTE:
 * Este componente e seus filhos implementam uma integração
 * sem uso de redux, para testes de conceito sobre o método
 * que estruturamos react.
 */

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';

// components
import ReceiptsItem from './ReceiptsItem';
import LoadingIndicator from '../../../../../components/LoadingIndicator';
import AlertMessage from '../../../../../components/AlertMessage';
import EmptyState from '../../../../../components/EmptyState';

// css
import './styles.css';

// utils
import InfoTitle from '../components/InfoTitle';
import ReceiptDetailHeader from '../components/ReceiptDetailHeader';
import InactivateReceiptStatusModal from '../components/InactivateReceiptStatusModal';
import { ActivateReceiptStatusModal } from '../components/ActivateReceiptStatusModal';
import DynamicAPI from '../../../../../shared/axios';
import { ReceiptDetailHistory } from './components/ReceiptDetailHistory';
import { USER_TYPES } from '../../../../Admin/shared/static-options';
import { connect } from 'react-redux';

const ReceiptContainer = styled.div`
  padding: 12px 24px 24px 24px;
`;

// enums
export const RECEIPT_TYPES = {
  OCCURRENCES: 0,
  RECEIPTS_ONLY: 1,
  DATA_MATRIX: 2,
  DELIVERY_RECEIPTS: 3,
  SIGNATURE: 4,
  ALL: 5,
};

export const receiptTypesToLabel = {
  [RECEIPT_TYPES.RECEIPTS_ONLY]: 'Canhoto do comprovante de entrega',
  [RECEIPT_TYPES.DELIVERY_RECEIPTS]: 'Comprovante de entrega',
  [RECEIPT_TYPES.OCCURRENCES]: 'Ocorrência',
  [RECEIPT_TYPES.DATA_MATRIX]: 'Data Matrix',
  [RECEIPT_TYPES.SIGNATURE]: 'Assinatura',
  [RECEIPT_TYPES.ALL]: 'Todos',
};

export const imageStatus = {
  ACTIVE: true,
  INACTIVE: false
};

class Receipts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showReceiptDetail: false,
      isLoading: false,
      error: null,
      response: [],
      filterOptions: [
        { value: RECEIPT_TYPES.ALL, label: 'Ver todos' },
        {
          value: RECEIPT_TYPES.DELIVERY_RECEIPTS,
          label: 'Apenas comprovantes de entrega',
        },
        {
          value: RECEIPT_TYPES.RECEIPTS_ONLY,
          label: 'Apenas canhoto de comprovantes',
        },
        { value: RECEIPT_TYPES.OCCURRENCES, label: 'Apenas ocorrências' },
        { value: RECEIPT_TYPES.DATA_MATRIX, label: 'Data Matrix' },
        { value: RECEIPT_TYPES.SIGNATURE, label: 'Assinatura' },
      ],
      selectedType: RECEIPT_TYPES.ALL,
      selectedReceiptIdentifier: null,
      selectedReceiptData: null,
      showReceiptStatusModal: false,
      currentReceiptStatus: null,
    };
  }

  componentDidMount() {
    this._getReceipts();
  }

  _getData = () => {
    const {
      nfData: {
        nf,
        nfGroup,
        cnpjEmit,
        tms: { tmsId },
      },
    } = this.props;

    return {
      nf,
      nfGroup,
      cnpjRemetente: cnpjEmit,
      idTms: tmsId,
    };
  };

  _getDataForInactivateReactivate = () => {
    const {
      nf,
      nfGroup,
      cnpjRemetente,
      idTms,
    } = this._getData();

    const {
      imageName
    } = this.state.selectedReceiptData;

    return {
      nf,
      nfGroup,
      cnpjRemetente,
      idTms,
      imageName
    }
  }

  _getReceipts = async () => {
    const {
      nf,
      nfGroup,
      cnpjRemetente,
      idTms
    } = this._getData();

    const params = {
      nf,
      nfGroup,
      cnpjRemetente,
      idTms,
    };

    this.setState({
      isLoading: true,
      error: null,
    });

    try {
      const http = new DynamicAPI('v2');
      const { data } = await http.get(
        '/IntegratedTracking/GetPhotosOccurrence',
        params,
      );

      this.setState({
        isLoading: false,
        response: data,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        error: error.message,
      });
    }
  };

  _getFilteredReceiptList = () => {
    const { response, selectedType } = this.state;

    if (selectedType === RECEIPT_TYPES.DELIVERY_RECEIPTS) {
      return response.filter(
        receipt => receipt.tipo === RECEIPT_TYPES.DELIVERY_RECEIPTS,
      );
    }

    if (selectedType === RECEIPT_TYPES.RECEIPTS_ONLY) {
      return response.filter(
        receipt => receipt.tipo === RECEIPT_TYPES.RECEIPTS_ONLY,
      );
    }

    if (selectedType === RECEIPT_TYPES.OCCURRENCES) {
      return response.filter(
        receipt => receipt.tipo === RECEIPT_TYPES.OCCURRENCES,
      );
    }

    if (selectedType === RECEIPT_TYPES.DATA_MATRIX) {
      return response.filter(
        receipt => receipt.tipo === RECEIPT_TYPES.DATA_MATRIX,
      );
    }

    if (selectedType === RECEIPT_TYPES.SIGNATURE) {
      return response.filter(
        receipt => receipt.tipo === RECEIPT_TYPES.SIGNATURE,
      );
    }
    return response;
  };

  _updateFilterValue = ({ value }) => {
    this.setState({
      selectedType: value,
    });
  };

  _toggleShowReceiptDetail = (link, data, status) => {
    this.setState((prevState) => ({
      showReceiptDetail: !prevState.showReceiptDetail,
      showReceiptDetailHistory: false,
      selectedReceiptIdentifier: link,
      selectedReceiptData: data,
      currentReceiptStatus: status
    }));

    if (data?.isHealthcare) {
      window.open(link, "_blank", "noreferrer");
    }
  }

  _backFromHistory = () => {
    this.setState((prevState) => ({
      ...prevState,
      showReceiptDetail: !prevState.showReceiptDetail,
      showReceiptDetailHistory: false,
    })
  )};

  _goToHistory = () => {
    this.setState((prevState) => ({
      ...prevState,
      showReceiptDetail: false,
      showReceiptDetailHistory: !prevState.showReceiptDetailHistory,
    }));
  }

  _closeReceiptModal = () => {
    this.setState({ showReceiptStatusModal: false });
  }

  _openReceiptModal = (data, status) => {
    this.setState({
      showReceiptStatusModal: true, 
      selectedReceiptData: data,
      currentReceiptStatus: status
    });
  }

  _changeReceiptActivateStatus = async () => {
    await this._getReceipts();
  }


  render() {
    const { isLoading, error, response, showReceiptDetail, showReceiptDetailHistory, selectedReceiptIdentifier, selectedReceiptData, showReceiptStatusModal, currentReceiptStatus } = this.state;

    const { userType } = this.props;

    return (
      <ReceiptContainer className="Receipts">
        {!showReceiptDetail && !showReceiptDetailHistory && (
          <InfoTitle>Fotos e Comprovantes</InfoTitle>
        )}
        {showReceiptDetail && !showReceiptDetailHistory && (
          <ReceiptDetailHeader
            onReturnToList={this._toggleShowReceiptDetail}
            goToHistory={this._goToHistory}
            selectedReceiptType={receiptTypesToLabel[selectedReceiptData.tipo]}
            date={selectedReceiptData.date}
            format={selectedReceiptData.fileFormat}
            size={selectedReceiptData.fileSize}
            status={currentReceiptStatus}
            history="Visualizar"
            userType={userType}
          />
        )}
        {!showReceiptDetail && showReceiptDetailHistory && (
          <ReceiptDetailHistory 
            onReturnToDetail={this._backFromHistory}
            date={selectedReceiptData.date}
            history={selectedReceiptData.history || []}
          />
        )}

        {showReceiptStatusModal && currentReceiptStatus === imageStatus.ACTIVE && (
          <InactivateReceiptStatusModal 
            data={this._getDataForInactivateReactivate()} 
            onBackdropClick={this._closeReceiptModal} 
            setInactive={this._changeReceiptActivateStatus}
          />
        )}

        {showReceiptStatusModal && currentReceiptStatus === imageStatus.INACTIVE && (
          <ActivateReceiptStatusModal 
            data={this._getDataForInactivateReactivate()} 
            onBackdropClick={this._closeReceiptModal} 
            setActivate={this._changeReceiptActivateStatus}
          />
        )}

        {isLoading && !error && (
          <LoadingIndicator
            className="Receipts__loading"
            text="Carregando..."
            theme="dark"
          />
        )}
        {error && !isLoading && (
          <AlertMessage
            error
            box
            message={error}
            actionText="Tente Novamente"
            onRetry={this._getReceipts}
          />
        )}

        {!isLoading && !error && !showReceiptDetailHistory && (
          <Fragment>
            <div className="Receipts__List">
              {this._getFilteredReceiptList().length > 0 &&
                this._getFilteredReceiptList(response).map(receipt => (
                  <>
                    {receipt.active === imageStatus.ACTIVE && (
                      <ReceiptsItem
                        key={receipt.link}
                        data={receipt}
                        showReceiptDetail={showReceiptDetail}
                        toggleShowReceiptDetail={this._toggleShowReceiptDetail}
                        selectedReceiptIdentifier={selectedReceiptIdentifier}
                        status={receipt.active}
                        openReceiptModal={this._openReceiptModal}
                        userType={userType}
                      />
                    )}
                    {receipt.active === imageStatus.INACTIVE && userType === USER_TYPES.CUSTOMER_SERVICE_USER && (
                      <ReceiptsItem
                        key={receipt.link}
                        data={receipt}
                        showReceiptDetail={showReceiptDetail}
                        toggleShowReceiptDetail={this._toggleShowReceiptDetail}
                        selectedReceiptIdentifier={selectedReceiptIdentifier}
                        status={receipt.active}
                        openReceiptModal={this._openReceiptModal}
                        userType={userType}
                      />
                    )}
                  </> 
                ))}
              {!error &&
                !isLoading &&
                this._getFilteredReceiptList().length === 0 && (
                  <EmptyState
                    message="Nenhum comprovante encontrado."
                    className="Receipts__List-empty"
                  />
                )}
            </div>
          </Fragment>
        )}
      </ReceiptContainer>
    );
  }
}

const mapStateToProps = state => ({
  userType: state.auth.userType,
});

export default connect(mapStateToProps)(Receipts);
